import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
//import { OptionCardContainer } from './style';
import { OptionCardContainer } from 'components/OptionCard/style';
//import OptionCard from 'components/OptionCard';
import { RoomOptionsContainer } from '../../style';
import Card from 'components/Card';
import { useRecoilState } from 'recoil';
import { selectedRooms } from 'states/CheckOutStates/atoms';
// import { GreenCheckIcon } from 'assets/icons';
import { RedCloseIcon, GreenCheckIconNew } from 'assets/icons';
import { useGetAvailableRooms } from 'customHooks/useGetAvailableRooms';
import { 
  MoneyIcon,
  CityView,
  Vompire

} from 'assets/icons';

import { roomPairs } from 'constants/roomTypeOptions';

const debug = false;

const RoomOptions: React.FC = () => {



  const history = useHistory();
  
  const [persistSelectedRooms, setPersistSelectedRooms] = useRecoilState(selectedRooms);
  const { searchResult, noAvailableRooms } = useGetAvailableRooms()
  
  // const windowRoomType = searchResult.find((roomType) => roomType.name === "Rook" || roomType.name === "Knight")
  // //const noWindowRoomType = searchResult.find((roomType) => roomType.name.includes("Inside"))

  // const noWindowRoomType = searchResult.find((roomType) => roomType.name.includes("Rook Inside"))

// Dictionary of pairs: "Inside" room - corresponding window 


// *** Now imported from roomTypeOptions

// const roomPairs: Record<string, { noWindow: string; window: string }> = {
//   "Rook Inside": { noWindow: "Rook Inside", window: "Rook" },
//   "Knight Inside": { noWindow: "Knight Inside", window: "Knight"},
//   "Rook": { noWindow: "Rook Inside", window: "Rook" },
//   "Knight": { noWindow: "Knight Inside", window: "Knight"},
//   "Bishop Inside": { noWindow: "Bishop Inside", window: "Pawn Inside" },
//   "Pawn Inside": { noWindow: "Bishop Inside", window: "Pawn Inside" },
// };






// Compute once on mount
const [roomTypes] = React.useState(() => {
  const currentPair = roomPairs[persistSelectedRooms.name];
  if (!currentPair) {
    return { noWindowRoomType: undefined, windowRoomType: undefined };
  }
  return {
    noWindowRoomType: searchResult.find(
      (roomType) => roomType.name === currentPair.noWindow
    ),
    windowRoomType: searchResult.find(
      (roomType) => roomType.name === currentPair.window
    ),
  };
});

const { noWindowRoomType, windowRoomType } = roomTypes;

  useEffect(() => {

    if (debug) {
      console.log ("searchResult.length = ", searchResult.length);
      console.log ("windowRoomType = ", windowRoomType);
      console.log ("noWindowRoomType = ", noWindowRoomType);
      console.log ("noWindowRoomType = ", noWindowRoomType);
    }

    if( searchResult.length && !(windowRoomType && noWindowRoomType)) {



      //history.push('/addOnOptions');
      history.push('/check-out');
    }
  }, [searchResult, windowRoomType, noWindowRoomType, history])

  
  useEffect (()=> {
    if (debug) {
      console.log ("selectedRooms from Room Options screen from localStorage:", selectedRooms);
      console.log ("selectedRooms from Room Options screen from Recoil:", persistSelectedRooms);
      console.log ("persistSelectedRooms.name = ", persistSelectedRooms.name);
    }
  }, [persistSelectedRooms])

  useEffect(() => {
    if (
      noWindowRoomType &&
      windowRoomType &&
      persistSelectedRooms &&
      persistSelectedRooms.roomTypeId !== noWindowRoomType.roomTypeId &&
      persistSelectedRooms.roomTypeId !== windowRoomType.roomTypeId
    ) {
      const updatedRooms = {
        ...persistSelectedRooms,
        roomTypeId: noWindowRoomType.roomTypeId,
        pricePerNight: noWindowRoomType.pricePerNight,
        name: noWindowRoomType.name,
        bed: noWindowRoomType.bed,
        hasWindows: noWindowRoomType.hasWindows,
      };
      setPersistSelectedRooms(updatedRooms);
      localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms));
    }
  }, [noWindowRoomType, windowRoomType, persistSelectedRooms, setPersistSelectedRooms]);
  

  return (
    <RoomOptionsContainer>
      {noAvailableRooms? (
        <>
          <div className="noRoomsTitle">
            The HORROR
          </div>
          <div className='noRoomsPicture'></div>
        </>
      ): (
        <>
          <div className="roomOptionsTitle">
            Room options:
          </div>

{/*  Maybe code below shold be refactored with more common logic in future  */}

          {noWindowRoomType && windowRoomType &&
            <>
              <Card selected={persistSelectedRooms.roomTypeId===noWindowRoomType.roomTypeId} style={{ cursor: 'pointer' }}>
                <OptionCardContainer
                  selected={persistSelectedRooms.roomTypeId===noWindowRoomType.roomTypeId}
                  className="optionsCard"
                  onClick={()=> {
                    const updatedRooms = {...persistSelectedRooms}
                    updatedRooms.roomTypeId = noWindowRoomType.roomTypeId
                    updatedRooms.pricePerNight = noWindowRoomType.pricePerNight
                    updatedRooms.name = noWindowRoomType.name
                    updatedRooms.bed = noWindowRoomType.bed
                    updatedRooms.hasWindows = noWindowRoomType.hasWindows
                    setPersistSelectedRooms(updatedRooms)
                    localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms))
                  }}
                >
                  <div className="optionCardTitle">
                    
                    {noWindowRoomType.name !== "Bishop Inside" &&
                    <div className="title">
                      A room with a skylight
                    </div>
                    }

                    {noWindowRoomType.name === "Bishop Inside" &&
                    <div className="title">
                      Embrace the darkness
                    </div>
                    }
                    
                    {noWindowRoomType.name === "Bishop Inside" &&
                    <div className="description">
                    <Vompire />
                      <span>Perfect for vampires</span>
                    </div>
                    }

                    {noWindowRoomType.name !== "Bishop Inside" &&
                    <div className="description">
                    <MoneyIcon />
                      <span>For the frugal minimalist</span>
                    </div>
                    }


                  </div>
                  {noWindowRoomType.name !== "Bishop Inside" &&
                  <div className="optionCardAttributesFeatures">
                    <div className="roomAttribute">
                      <GreenCheckIconNew />
                      Most affordable option
                    </div>
                    <div className="roomAttribute">
                      <GreenCheckIconNew />
                      Natural light
                    </div>
                    <div className="roomAttribute roomAttributeCross">
                      <RedCloseIcon />
                      No window
                    </div>

                  </div>
                  }
                  {noWindowRoomType.name === "Bishop Inside" &&
                  <div className="optionCardAttributesFeatures">
                    <div className="roomAttribute">
                      <GreenCheckIconNew />
                      Great for sleeping during the day
                    </div>
                    <div className="roomAttribute">
                      <GreenCheckIconNew />
                      Most affordable option
                    </div>
                    <div className="roomAttribute roomAttributeCross">
                      <RedCloseIcon />
                      No windows or skylight
                    </div>

                  </div>
                  }
                  <div className="windowsOption">
                    <div className="radioAndPrice">
                    <div className="customizedRadio"></div>
                    <div className="optionDescription">
                      Included in current room price
                    </div>
                    </div>
                  </div>
                </OptionCardContainer>
              </Card>
              <Card selected={persistSelectedRooms.roomTypeId===windowRoomType.roomTypeId} style={{ cursor: 'pointer' }}>
                <OptionCardContainer
                  selected={persistSelectedRooms.roomTypeId===windowRoomType.roomTypeId}
                  onClick={()=> {
                    const updatedRooms = {...persistSelectedRooms}
                    updatedRooms.roomTypeId = windowRoomType.roomTypeId
                    updatedRooms.pricePerNight = windowRoomType.pricePerNight
                    updatedRooms.name = windowRoomType.name
                    updatedRooms.bed = windowRoomType.bed
                    updatedRooms.hasWindows = windowRoomType.hasWindows
                    setPersistSelectedRooms(updatedRooms)
                    localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms))
                  }}
                >
                  {windowRoomType.name === "Pawn Inside" &&
                  <div className="optionCardTitle">
                    <div className="title">A room with a skylight</div>
                    <div className="description">
                    <MoneyIcon />
                      <span>For the frugal minimalist</span>
                    </div>
                  </div>
                  }
                  {windowRoomType.name !== "Pawn Inside" &&
                  <div className="optionCardTitle">
                    <div className="title">A room with a view</div>
                    <div className="description">
                    <CityView />
                      <span>Enjoy the cityscape</span>
                    </div>
                  </div>
                  }
                  {windowRoomType.name !== "Pawn Inside" &&
                  <div className="optionCardAttributesFeatures">
                    <div className="roomAttribute">
                      <GreenCheckIconNew />
                      Large windows with view of downtown
                    </div>
                  </div>
                  }
                  {windowRoomType.name === "Pawn Inside" &&
                  <div className="optionCardAttributesFeatures">
                  <div className="roomAttribute">
                    <GreenCheckIconNew />
                    Most affordable option
                  </div>
                  <div className="roomAttribute">
                    <GreenCheckIconNew />
                    Natural light
                  </div>
                  <div className="roomAttribute roomAttributeCross">
                    <RedCloseIcon />
                    No window
                  </div>
                  </div>
                  }

                  <div className="windowsOption">
                    <div className="radioAndPrice">
                    <div className="customizedRadio"></div>
                    <div className="optionDescription">
                      {((windowRoomType.pricePerNight - noWindowRoomType.pricePerNight)>0? '+': '') + `$${(windowRoomType.pricePerNight - noWindowRoomType.pricePerNight).toFixed(2)}`}
                    </div>
                    </div>
                    <div className="explanation">
                      per night, not including tax / fees
                    </div>
                  </div>
                </OptionCardContainer>
              </Card>
            </>
          }
        </>
      )}
    </RoomOptionsContainer>
  );
}

export default RoomOptions;
